<template>
  <div class="Card">
    <div class="Card-content">
      <component
        :is="isModules"
        :status="status"
        :details="details"
        @action="action"
      ></component>
    </div>
  </div>
</template>
<script>
import myCard from './index.js'
export default {
  props: {
    //模块
    modules:{
        type:String,
        default:'nfts'
    },
    //卡片数据
    details:{
        type:Object
    },
    //状态
    status:{
        type:String,
        default:''
    }
  },
  data() {
    return {
        isModules:null
    };
  },
  created(){
    console.log('公共卡片')
    this.isModules = myCard[this.modules];
  },
  methods: {
    //操作
    action(details){
        this.$emit('action',details)
    }
  },
};
</script>
<style lang="scss" scoped>
.Card {
}
</style>
